import 'moment/locale/id';
import * as ExcelJS from 'exceljs';
import 'moment-duration-format';
import { UserModel } from '../../app/modules/auth/models/UserModel';
import { CustomField } from '../../interfaces/Settings';
import { addNumberFormatting, createSingleOptionWorksheets, exportWorkbook, generateWorksheetNameColumnCustomField, getColumnExcelNameLetter, setColumnWidths, styleColumns } from './helperTemplateExcel';
import { addWorkSheetInfo } from './helperTemplateExcel';
import { createWorksheet } from './helperTemplateExcel';
import { createWorkbook } from './helperTemplateExcel';
import { MultiSimplePipeline, SimplePipeline } from '../../interfaces/Pipeline';
import { MultiSimpleMerchant, SimpleMerchant } from '../../interfaces/Merchant';
import { MultiSimpleMeeting, SimpleMeeting } from '../../interfaces/Meeting';
import { addSingleOptionValidation, getCellNote } from './functionHelperExcel';
import { User } from '../../interfaces/User';

interface ExportTemplateUserExcelProps {
    nameFile: string,
    customFields: CustomField,
    source: string,
    typeAction: string,
    settings: any,
    nameInfo: string,
    nameHeader: any,
    setIsLoading: React.Dispatch<React.SetStateAction<boolean>>,
    user: UserModel,
    param: any,
    simpleCustomFieldsMaster: {
        pipelines: MultiSimplePipeline
        meetings: MultiSimpleMeeting
        merchants: MultiSimpleMerchant
        users: Record<string, User[]>;
    },
    intl: any,
    type?: string,
}

export const exportTemplateUserExcel = async ({ nameFile, customFields, source, typeAction, settings, nameInfo, nameHeader, setIsLoading, user, param, simpleCustomFieldsMaster, type, intl }: ExportTemplateUserExcelProps) => {
    let exportData: any[] = [];
    const workbook = createWorkbook();
    const worksheet = createWorksheet(workbook, "Sheet1");
    const worksheetInfo = createWorksheet(workbook, "Info");
    var header: string[] = []
    var subHeader: string[] = []


    let worksheetCity = workbook.addWorksheet('Daftar Kota');
    await worksheetCity.protect('mjioerh3uiqWHEIOPHQWIOPEJHDWBH', {
        formatColumns: true,
        autoFilter: true,
    });

    worksheetCity.getCell('A1').value = `Daftar Kota`;
    await param.dataCities.forEach((user: any) => {
        worksheetCity.addRow([user.name]);
    });

    // Data Role
    let worksheetRole = workbook.addWorksheet('Daftar Role');
    await worksheetRole.protect('mjioerh3uiqWHEIOPHQWIOPEJHDWBH', {
        formatColumns: true,
        autoFilter: true,
    });

    worksheetRole.getCell('A1').value = `Daftar Role`;
    await param.dataRoles.forEach((user: any) => {
        worksheetRole.addRow([user.name]);
    });

    // Data Leader
    let worksheetLeader = workbook.addWorksheet('Daftar Atasan');
    await worksheetLeader.protect('mjioerh3uiqWHEIOPHQWIOPEJHDWBH', {
        formatColumns: true,
        autoFilter: true,
    });

    worksheetLeader.getCell('A1').value = `Daftar Atasan`;
    await param.dataLeaders.forEach((user: any) => {
        worksheetLeader.addRow([user.name]);
    });

    // Data Attendance Database
    let worksheetAttendanceTemplate = workbook.addWorksheet('Daftar Database Absen');

    await worksheetAttendanceTemplate.protect('mjioerh3uiqWHEIOPHQWIOPEJHDWBH', {
        formatColumns: true,
        autoFilter: true,
    });

    worksheetAttendanceTemplate.getCell('A1').value = `Daftar Database Absen`;
    await param.dataAttendanceTemplates.forEach((user: any) => {
        worksheetAttendanceTemplate.addRow([user.name]);
    });

    // Daftar Single Option
    const singleOptionSheetsUsers = createSingleOptionWorksheets({ customFields, workbook, simpleCustomFieldsMaster, user, intl });

    header = [...nameHeader.insert.user.header];
    subHeader = [...nameHeader.insert.user.subHeader];

    if (typeAction === 'insert') {

        if (type === 'error') {
            header.push('Error')
            subHeader.push(nameHeader.error)
            Array.from(param.listErrorInsert).map((row: any, index) => {
                var temp_excel = [];

                temp_excel.push(
                    row.username,
                    row.name,
                    row.nik,
                    row.phone,
                    row.password,
                    row.leader_name,
                    row.city_name,
                    row.role_name,
                    row.attendanceTemplate_name,
                    row.date_join,
                    ...Object.keys(customFields).map((key: any) =>
                        row[key]
                    ),
                    row.error
                );

                exportData.push(temp_excel);
            });
        }

    } else if (typeAction === 'update') {
        await worksheet.protect('mjioerh3uiqWHEIOPHQWIOPEJHQWIO', {
            formatColumns: true,
            autoFilter: true
        });

        if (type === 'error') {
            header.push('Error')
            subHeader.push(nameHeader.error)
            Array.from(param.listErrorUpdate).map((row: any, index) => {
                var temp_excel = [];

                temp_excel.push(
                    btoa(row.id.slice(0, 3) + Math.floor(100 + Math.random() * 900) + row.id.slice(3)),
                    row.name,
                    row.nik,
                    row.leader_name,
                    row.city_name,
                    row.role_name,
                    row.attendanceTemplate_name,
                    ...Object.keys(customFields).map((key: any) =>
                        row[key]
                    ),
                    row.error
                );

                exportData.push(temp_excel);
            });
        } else {
            param.dataTables.map((row: any) => {

                var temp_excel = [];

                temp_excel.push(
                    btoa(row.id.slice(0, 3) + Math.floor(100 + Math.random() * 900) + row.id.slice(3)),
                    row.name,
                    row.nik,
                    row.leader_name,
                    row.city_name,
                    row.role_name,
                    row.attendanceTemplateName,
                    ...Object.keys(customFields).map((field: any) => {
                        if (row.customFields?.hasOwnProperty(field)) {
                            // Tambahkan pengecekan untuk tipe 'option' dan 'image' di sini
                            if (customFields[field].type === 'option' && row.customFields[field] === undefined) {
                                return null;
                            }
                            if (customFields[field].type === 'image') {
                                return Array.isArray(row.customFields[field]) ? row.customFields[field][0] : row.customFields[field];
                            }
                            return row.customFields[field];
                        } else {
                            return null;
                        }
                    }),
                    row.error
                );

                exportData.push(temp_excel)
            })
        }
    }

    worksheet.getRow(1).values = header;
    worksheet.getRow(2).values = subHeader;
    setColumnWidths(worksheet, source, header!, exportData);
    styleColumns(worksheet, source, 1);
    styleColumns(worksheet, source, 2);
    addDataRows(worksheet, exportData, customFields, source, type!, typeAction, user!, param, singleOptionSheetsUsers, simpleCustomFieldsMaster);
    addWorkSheetInfo(worksheetInfo, source, nameFile, nameInfo, nameHeader, user!);

    exportWorkbook(workbook, worksheet, source, `${nameFile}.xlsx`, setIsLoading);
};

const addDataRows = (
    worksheet: ExcelJS.Worksheet,
    data: any[],
    customFields: CustomField,
    source: string,
    type: string,
    typeAction: string,
    user: UserModel,
    param?: any,
    singleOptionSheets?: any,
    simpleCustomFieldsMaster?: {
        pipelines: MultiSimplePipeline
        meetings: MultiSimpleMeeting
        merchants: MultiSimpleMerchant
        users: Record<string, User[]>;
    }
) => {
    data.forEach((rowData, index) => {
        worksheet.addRow(rowData);
    });

    // const addSingleOptionValidation = (startColumn: string, customFields: any) => {
    //     let currentColumn = startColumn.charCodeAt(0);
    //     Object.entries(customFields).forEach(([key, field]: [string, any]) => {
    //         if (field.type === 'option') {
    //             const { columnLetter, worksheetName, dataLength } = getColumnExcelNameLetter(currentColumn, singleOptionSheets, key, typeAction, type, param);
    //             for (let i = 3; i <= (typeAction === 'update' ? dataLength + 2 : 1000); i++) {
    //                 worksheet.getCell(`${columnLetter}${i}`).dataValidation = {
    //                     type: 'list',
    //                     allowBlank: true,
    //                     showErrorMessage: true,
    //                     formulae: [`='${worksheetName}'!$A$2:$A$${field.value.length + 1}`],
    //                     errorStyle: 'error',
    //                     error: `Pilih ${field.name}`,
    //                 };
    //             }
    //         } else if (field.type === 'pipeline') {
    //             const { columnLetter, worksheetName } = getColumnExcelNameLetter(currentColumn, singleOptionSheets, key, typeAction, type, param);
    //             for (let i = 3; i <= 3; i++) {
    //                 worksheet.getCell(`${columnLetter}${i}`).dataValidation = {
    //                     type: 'list',
    //                     allowBlank: true,
    //                     showErrorMessage: true,
    //                     formulae: [`='${worksheetName}'!$A$2:$A$${(simpleCustomFieldsMaster?.pipelines?.length || 0) + 1}`],
    //                     errorStyle: 'error',
    //                     error: `Pilih ${field.name}`,
    //                 };
    //             }
    //         } else if (field.type === 'meeting') {
    //             const { columnLetter } = getColumnExcelNameLetter(currentColumn, singleOptionSheets, key, typeAction, type, param);
    //             for (let i = 3; i <= 3; i++) {
    //                 const cell = worksheet.getCell(`${columnLetter}${i}`);
    //                 cell.note = getCellNote(field);
    //             }
    //         } else if (field.type === 'merchant') {
    //             const { columnLetter } = getColumnExcelNameLetter(currentColumn, singleOptionSheets, key, typeAction, type, param);
    //             for (let i = 3; i <= 3; i++) {
    //                 const cell = worksheet.getCell(`${columnLetter}${i}`);
    //                 cell.note = getCellNote(field);
    //             }
    //         } else if (field.type === 'user') {
    //             const { columnLetter } = getColumnExcelNameLetter(currentColumn, singleOptionSheets, key, typeAction, type, param);
    //             for (let i = 3; i <= 3; i++) {
    //                 const cell = worksheet.getCell(`${columnLetter}${i}`);
    //                 cell.note = getCellNote(field);
    //             }
    //         } else if (field.type === 'multiple') {
    //             const { columnLetter } = getColumnExcelNameLetter(currentColumn, singleOptionSheets, key, typeAction, type, param);
    //             for (let i = 3; i <= 3; i++) {
    //                 const cell = worksheet.getCell(`${columnLetter}${i}`);
    //                 cell.note = getCellNote(field);
    //             }
    //         }
    //         currentColumn++;
    //     });
    // };

    for (let i = 3; i < 550; i++) {
        for (let i = 3; i <= 550; i++) {
            worksheet.getCell('F' + i).dataValidation = {
                type: 'list',
                allowBlank: false,
                showErrorMessage: true,
                formulae: [`='Daftar Atasan'!$A$2:$A$${param.dataLeaders.length + 2}`],
                errorStyle: 'error',
                error: 'Pilih atasan',
            };

            worksheet.getCell('G' + i).dataValidation = {
                type: 'list',
                allowBlank: false,
                showErrorMessage: true,
                formulae: [`='Daftar Kota'!$A$2:$A$${param.dataCities.length + 2}`],
                errorStyle: 'error',
                error: 'Pilih kota',
            };

            worksheet.getCell('H' + i).dataValidation = {
                type: 'list',
                allowBlank: false,
                showErrorMessage: true,
                formulae: [`='Daftar Role'!$A$2:$A$${param.dataRoles.length + 2}`],
                errorStyle: 'error',
                error: 'Pilih role',
            };

            worksheet.getCell('I' + i).dataValidation = {
                type: 'list',
                allowBlank: false,
                showErrorMessage: true,
                formulae: [`='Daftar Database Absen'!$A$2:$A$${param.dataAttendanceTemplates.length + 2}`],
                errorStyle: 'error',
                error: 'Pilih database absen',
            };
        }
        addSingleOptionValidation('K', customFields, singleOptionSheets, typeAction, type, param, worksheet, simpleCustomFieldsMaster);
        addNumberFormatting('K', customFields, typeAction, type, param, worksheet);
    }
};
